import { memo, useState, useEffect, useRef } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { useStore } from 'store/StoreContext';
import { callGetUserApi, callUpdateUserApi } from 'requests/RequestUser';
import { copyObject } from 'common/copyObject';
import { RoutePath } from 'consts/RoutePath';
import { CircularProgress, Backdrop } from '@material-ui/core';
import classes from './override.module.scss';
import { HttpStatus } from 'consts/HttpStatus';
import { Hr } from 'components/atoms/Hr';
import { CompleteDialog } from 'components/organisms/CompleteDialog';

type Props = {};

export const EmailDeliveryTemplate = memo((_props: Props) => {
	const history = useHistory();
	const [store] = useStore();
	const [formData, setFormData] = useState({ directmail_flg: 0 });
	const [getUserLoading, setGetUserLoading] = useState(false);
	useEffect(() => {
		const execute = async () => {
			setGetUserLoading(true);
			const getUserResult = await callGetUserApi();
			if (getUserResult.status !== HttpStatus.OK || !getUserResult.data) {
				history.push(RoutePath.ERROR);
				return;
			}
			if (!!store.loginUserData.gidpk && getUserResult.status === HttpStatus.OK && !!getUserResult.data) {
				const user = copyObject(getUserResult.data);
				setFormData({ directmail_flg: user.directmail_flg });
			}
			setGetUserLoading(false);
		};
		execute();
	}, []);

	const handleChangeCheckValue = (event: React.ChangeEvent<HTMLInputElement>) => {
		setFormData((prev) => ({ ...prev, [event.target.name]: event.target.checked ? 1 : 0 }));
	};

	const [isCompleteDialogOpen, setIsCompleteDialogOpen] = useState(false);
	const handleCompleteDialogOpen = () => {
		setIsCompleteDialogOpen(true);
	};
	const handleCompleteDialogClose = () => {
		setIsCompleteDialogOpen(false);
		history.push(RoutePath.MY_PAGE);
	};

	const [processLoading, setProcessLoading] = useState(false);
	const update = async () => {
		setProcessLoading(true);
		const result = await callUpdateUserApi({
			isGidChange: false,
			data: { directmail_flg: formData.directmail_flg },
		});
		if (result.status !== HttpStatus.OK) {
			setProcessLoading(false);
			history.push(RoutePath.ERROR);
			return;
		}
		setProcessLoading(false);
		handleCompleteDialogOpen();
	};

	const scrollRef = useRef(null);
	useEffect(() => {
		scrollRef.current.scrollIntoView();
		document.title = 'GakkenIDマイページ｜メール配信';
	}, []);

	return (
		<>
			<Backdrop className={classes.backdrop} open={getUserLoading || processLoading}>
				<CircularProgress color="inherit" />
			</Backdrop>
			<section className="section mypage" ref={scrollRef}>
				<div className="breadcrumb">
					<ul>
						<li>
							<Link to={RoutePath.MY_PAGE}>マイページTOP</Link>
						</li>
						<li>メール配信</li>
					</ul>
				</div>

				<h1 className="page-head">メール配信</h1>
				<div className="section-in">
					<div className="section-head">メルマガの配信状況</div>
					<div className="section-txt-box">
						<div className="txt">
							GakkenIDで使用できるサービスや、関連するサービスの情報をお届けします。
							<br />
							変更する場合はチェックボックスをクリックした後「変更する」ボタンを押してください。
						</div>
					</div>
					<Hr />
					<div className={`form-box ${classes.customFormBox}`}>
						<div className="form-input">
							<div className="check-box">
								<ul>
									<li>
										<label
											className={`check-label ${formData.directmail_flg === 1 ? 'is-active' : ''}`}
											htmlFor="agree"
										>
											<input
												type="checkbox"
												id="agree"
												name="directmail_flg"
												checked={formData.directmail_flg === 1}
												onChange={handleChangeCheckValue}
											/>
											GakkenIDサービスメルマガを受け取る
										</label>
									</li>
								</ul>
							</div>
						</div>
					</div>
					<Hr />
					<div className="btn-box">
						<div className="btn gr">
							<button onClick={update}>変更する</button>
						</div>
					</div>
				</div>
			</section>
			{/* 完了ダイアログ */}
			<CompleteDialog isOpen={isCompleteDialogOpen} doTrans={handleCompleteDialogClose} />
		</>
	);
});
